import { Database } from '../components/main/options/model/types'
import { BASE_SERVICE_URL } from '../lib/constants'
import globalNotification from 'live/services/global-notification'
import { getUser } from './helper/getUser'

export async function createDatabase(database: Database): Promise<boolean> {
    try {
        const status = (await fetch(BASE_SERVICE_URL + `/model/create`, {
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(database)
        })
            .then(response => {
                if (response.ok) {
                    return 'created'
                }
                return response.json()
            })
            .then(result => {
                if (result === 'created') return result
                return result.error
            })) as string

        if (status == 'created') {
            globalNotification.success(`Model successfully saved: ${database.eventType}.`)
            return true
        } else {
            globalNotification.error(`Error database: ${database.eventType}.
            ${status}
          `)
            return false
        }
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function createDatabaseByFile(
    database: Database,
    uid: string,
    fileName: string,
    sheetIndex: string
): Promise<boolean> {
    try {
        const status = (await fetch(BASE_SERVICE_URL + `/model/createByFile`, {
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ ...database, uid, fileName, sheetIndex, username: getUser() })
        })
            .then(response => {
                if (response.ok) {
                    return 'created'
                }
                return response.json()
            })
            .then(result => {
                if (result === 'created') return result
                return result.error
            })) as string

        if (status == 'created') {
            globalNotification.success(`Model successfully saved: ${database.eventType}.`)
            return true
        } else {
            globalNotification.error(`Error database: ${database.eventType}.
            ${status}
          `)
            return false
        }
    } catch (error) {
        console.error(error)
        return false
    }
}
